<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="YongHuList">
      <li
        v-if="state.select_count > 0"
        class="text-sm text-gray-400 flex items-center"
      >
        已选
        <strong class="text-orange-600 mx-1">{{ state.select_count }}</strong>
        条数据
        <el-button type="danger" link @click="onClearSelect"> 清空 </el-button>
      </li>
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Select"
        @click="onSubmit()"
        :disabled="!state.select_count"
      >
        提交
      </el-button>
    </div>
    <div class="flex-1 overflow-hidden flex gap-x-3 mt-2">
      <c_bumen
        @node-change="
          (id) => {
            state.params.department_id = id;
            onLoad();
          }
        "
      />
      <div class="content">
        <el-table
          ref="tableDom"
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          row-key="id"
          @selection-change="onSelectChange"
          @row-click="onRowClick"
        >
          <el-table-column type="selection" width="55" reserve-selection />
          <el-table-column :width="140">
            <template #header>
              <div class="c-table-col-header" label1="姓名" label2="性别" />
            </template>
            <template #default="{ row }">
              <div class="flex items-center gap-x-1">
                <strong>{{ row.name }}</strong>
                <el-icon v-if="row.sex == '男'"
                  ><Male color="#1e90ff"
                /></el-icon>
                <el-icon v-else style="transform: rotate(180deg)"
                  ><Male color="#f00"
                /></el-icon>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="所属部门"
            prop="department_name"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="手机号"
            prop="phone"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="职务"
            prop="job"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="担任角色"
            prop="job"
            :formatter="$tab_TextFormat"
          >
            <template #default="{ row }">
              <el-select
                v-if="state.select_ids?.includes(row.id)"
                v-model="row.d_service_person_role_id"
                placeholder="请选择担任角色"
                @click.stop=""
                :disabled="!state.select_ids?.includes(row.id)"
                @change="onRoleChange(row)"
              >
                <el-option
                  v-for="item in state.role_data"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <text v-else>-</text>
            </template>
          </el-table-column>
        </el-table>
        <c_page
          :total="state.totalCount"
          :pageIndex="state.params.page"
          :pageSize="state.params.limit"
          @onLoad="
            (page) => {
              state.params.page = page.pageIndex;
              state.params.limit = page.pageSize;
              onLoad();
            }
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_getAdmin_page, dic_getServicePersonRole } from "@/http/data";
import { meeting_service_person_add } from "@/http/meeting";
import { ElMessage, ElMessageBox } from "element-plus";
import { post_response } from "@/utils/funcs";

import c_bumen from "@/views/BuMen/Index.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
    not_ids: Array,
  },
  components: {
    c_bumen,
  },
  setup(props, { emit }) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      role_bak: [], //已选角色备份，用于查询后回显
    });
    onMounted(() => {
      state.params.not_ids = props.not_ids;
      onLoadRole();
      onLoad();
    });

    const onLoadRole = () => {
      dic_getServicePersonRole().then((res) => {
        if (res.status == 200) {
          state.role_data = res.data?.data;
        }
      });
    };

    const onLoad = () => {
      delete state.bmData;

      data_getAdmin_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;

          //回显已选角色
          state.role_bak.forEach((w) => {
            let model = list.find((m) => m.id == w.id);
            if (model) {
              model.d_service_person_role_id = w.d_service_person_role_id;
            }
          });
        }
      });
    };

    const onRowClick = (item) => {
      tableDom.value.toggleRowSelection(item);
    };

    //角色改变事件
    const onRoleChange = (item) => {
      let model = state.role_bak.find((w) => w.id == item.id);

      if (model?.id) {
        model.d_service_person_role_id = item.d_service_person_role_id;
      } else {
        state.role_bak.push({
          id: item.id,
          d_service_person_role_id: item.d_service_person_role_id,
        });
      }
    };

    //选择项改变事件
    const onSelectChange = (e) => {
      state.select_count = e.length;
      state.select_ids = e.map((m) => m.id);
    };

    //清空已选
    const onClearSelect = () => {
      tableDom.value.clearSelection();
      state.select_count = 0;
    };

    const onSubmit = () => {
      if (!state.select_count) {
        ElMessage.error("请选择要操作的人员");
        return;
      }

      const rows = tableDom.value.getSelectionRows();

      if (rows.some((w) => !w.d_service_person_role_id)) {
        ElMessage.error("请选择担任角色");
        return;
      }

      ElMessageBox.confirm(
        `您确定<strong style="color:#080;">添加</strong><strong style='color:#1e90ff'>${rows.length}名</strong>项目人员吗？`,
        "添加项目人员",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_service_person_add({
          meeting_id: props.meeting_id,
          batch_data: rows.map((m) => ({
            d_service_person_role_id: m.d_service_person_role_id,
            admin_id: m.id,
            is_selected: 1,
          })),
        }).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              emit("close", true);
            }, 500);
          });
        });
      });
    };

    return {
      state,
      onLoad,
      onLoadRole,
      tableDom,
      onRowClick,
      onSelectChange,
      onClearSelect,
      onSubmit,
      onRoleChange,
    };
  },
};
</script>

<style lang="scss" scoped></style>
